import { render, staticRenderFns } from "./admin-fields.vue?vue&type=template&id=99de90f8"
import script from "./admin-fields.vue?vue&type=script&lang=js"
export * from "./admin-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports